function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  fill: "#FFDBDC",
  cx: 100,
  cy: 100,
  r: 100
});

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#6D6D6D",
  d: "M142.072,96.497H61.588v27.742c0,0,13.907,15.09,40.242,15.09s40.242-15.09,40.242-15.09V96.497z"
});

var _ref4 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polygon", {
  fill: "#333333",
  points: "101.83,60.669 28.66,88.112 101.83,115.551 175,88.112 "
});

var _ref5 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polygon", {
  fill: "#D5007F",
  points: "25,106.401 32.32,106.401 28.66,88.112 "
});

var _ref6 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polygon", {
  fill: "#DB2491",
  points: "173.952,199.999 173.952,147.891 181.527,147.891 188.162,199.999 181.053,193.409 "
});

var _ref7 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polygon", {
  fill: "#ED92C8",
  points: "173.952,199.999 173.952,147.891 166.372,147.891 159.738,199.999 166.847,193.409 "
});

var _ref8 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polygon", {
  fill: "#E76DB6",
  points: "173.952,111.783 178.074,109.999 181.449,112.972 185.923,112.551 188.216,116.421 192.601,117.398  193.583,121.791 197.453,124.076 197.025,128.55 200,131.922 198.216,136.052 200,140.175 197.025,143.548 197.453,148.023  193.583,150.314 192.601,154.7 188.216,155.684 185.923,159.552 181.449,159.132 178.074,162.106 173.952,160.315 169.822,162.106  166.451,159.132 161.975,159.552 159.691,155.684 155.298,154.7 154.315,150.314 150.446,148.023 150.876,143.548 147.898,140.175  149.684,136.052 147.898,131.922 150.876,128.55 150.446,124.076 154.315,121.791 155.298,117.398 159.691,116.421 161.975,112.551  166.451,112.972 169.822,109.999 "
});

var _ref9 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#D5007F",
  d: "M192.898,136.052c0-10.467-8.487-18.945-18.946-18.945c-10.464,0-18.944,8.479-18.944,18.945 s8.48,18.946,18.944,18.946C184.411,154.998,192.898,146.519,192.898,136.052z"
});

var SvgCursoAprobado = function SvgCursoAprobado(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    width: "200px",
    height: "200px",
    viewBox: "0 0 200 200",
    enableBackground: "new 0 0 200 200",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCursoAprobado, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cursoAprobado.d7deaf32.svg";
export { ForwardRef as ReactComponent };